import { createSvgComponent } from "../../icon/createSvgComponent";
import Donations from "@core/icon/assets/donations.svg";
export default createSvgComponent(Donations);